import { icon } from "@fortawesome/fontawesome-svg-core";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import sourceIcon from "@img/icon/bankmonitor.json";

export const faBankmonitor = icon(sourceIcon as IconDefinition);
